import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import Fold1 from "../components/Fold1/Fold1";
import Fold2 from "../components/Fold2/Fold2";
import Fold4 from "../components/Fold4/Fold4";
import { useSearchParams } from "react-router-dom";
import TrackingComponent from "../components/Tracking/TrackingComponent";
import SolveMarketingChallenges from "../components/SolveMarketingChallenges/SolveMarketingChallenges";

import { Helmet } from "react-helmet-async";
import GetStartedRequestDemoSide from "../components/generic/GetStartedRequestDemoSide";
import { lightThemeColors } from "../assets/style/colors";
import { ReactComponent as GridAssetIcon } from "../assets/decorations/blueBannerGrid.svg";

const LandingPage = () => {

  const [searchParams, setSearchParams] = useSearchParams();



  useEffect(() => {
    const element = searchParams.get("scrollTo");
    if (element) {
      let scrollToElement = document.getElementById(element);
      scrollToElement.scrollIntoView({ behavior: "smooth" });
      setSearchParams((prev) => {
        prev.delete("scrollTo");
      });
    }
  }, []);



  return (
    <>
      <Helmet>
        <title>Grovs | App Growth Solved with Smart Links & Attribution</title>
        <meta
          name="description"
          content="Drive app installs, increase engagement, and maximize ROI with Grovs. Use smart links, deep linking, and actionable insights to scale your app growth effectively."
        />
        <meta
          name="keywords"
          content="app growth, smart links, app installs, deep linking, mobile attribution, user engagement, campaign tracking, referral marketing, mobile analytics, Grovs"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Grovs | App Growth Solved with Smart Links & Attribution"
        />
        <meta
          property="og:description"
          content="Optimize mobile marketing with Grovs. Track installs, guide users, increase engagement, and get actionable campaign insights. Start growing today."
        />
        <meta property="og:url" content="https://www.grovs.io" />
        <meta
          property="og:image"
          content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Grovs | App Growth Solved" />
        <meta
          name="twitter:description"
          content="Grovs helps you grow your app with smart links, referral tracking, and performance insights that maximize ROI and user engagement."
        />
        <meta
          name="twitter:image"
          content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
        />
      </Helmet>

      <Container >
        <Fold1 />
        <Fold2 />
        <SolveMarketingChallenges />
        <Fold4 />

        <GetStartedRequestDemoSide
          bgColor={lightThemeColors.measureBg}
          gradientColor={"rgba(91, 104, 223, 1)"}
          titleStyle={{ color: lightThemeColors.lightColor }}
          subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
          gridDecoration={<GridAssetIcon />}
          primaryButtonStyle={{ color: lightThemeColors.lightColor }}
          primaryButtonVariant={lightThemeColors.footerBg}
          outlineButtonStyle={{
            color: lightThemeColors.darkColor,
            background: lightThemeColors.lightColor,
          }}
          outlineButtonVariant={lightThemeColors.lightColor}
          title={
            " Are you ready to boost your app's growth?"
          }
          subtitle={
            "Create a free account - no card required."
          }
        />
        <TrackingComponent />
      </Container>
    </>
  );
};

export default LandingPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
